/**
 * GlobalMetaInfoManagerDialog
 *
 * App-level mount of the MetaInfo manager dialog, driven by
 * `useMetaInfoManagerDialogStore` so any feature (e.g. the database
 * context menu in the Object Explorer) can open it without prop drilling.
 */

import { MetaInfoManagerDialog } from './MetaInfoManagerDialog';
import { useMetaInfoManagerDialogStore } from './metaInfoManagerDialogStore';

export function GlobalMetaInfoManagerDialog() {
  const { isOpen, connectionId, database, closeDialog } = useMetaInfoManagerDialogStore();

  if (!isOpen) return null;

  return (
    <MetaInfoManagerDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) closeDialog();
      }}
      connectionId={connectionId}
      database={database}
    />
  );
}
